// tendremos centralizados los types de la autenticación
export const types = {
  login: '[Auth] Login',
  logout: '[Auth] Logout',
  setToken: '[Auth] SetToken',
  changeSucursal: '[Auth] ChangeSucursal'
};
